/**
 * KLS Customer Service Chat Widget
 * Paste into Shopify: Assets → kls-agent.js
 */

(function () {
  "use strict";

  const KLS_AGENT_URL = "https://kls-agent-production.up.railway.app";

  const WELCOME_MSG =
    "Hi! I'm here to help with your Kendall Layne Studio order, answer questions about our jewelry, or help you join the early access list for upcoming drops. What can I help you with?";

  const QUICK_REPLIES = [
    "Track my order",
    "Tell me about the current drop",
    "How do returns work?",
    "Custom piece inquiry",
  ];

  // ── Styles ─────────────────────────────────────────────────────────────────
  const css = `
    #kls-chat-launcher {
      position: fixed;
      bottom: 24px;
      right: 24px;
      width: 56px;
      height: 56px;
      border-radius: 50%;
      background: #1C1C1C;
      border: 2px solid #C9A96E;
      cursor: pointer;
      z-index: 9999;
      display: flex;
      align-items: center;
      justify-content: center;
      box-shadow: 0 4px 20px rgba(0,0,0,0.25);
      transition: transform 0.2s ease, box-shadow 0.2s ease;
    }
    #kls-chat-launcher:hover {
      transform: scale(1.08);
      box-shadow: 0 6px 28px rgba(0,0,0,0.35);
    }
    #kls-chat-launcher svg { transition: opacity 0.2s; }
    #kls-chat-launcher .kls-icon-chat { opacity: 1; }
    #kls-chat-launcher .kls-icon-close { opacity: 0; position: absolute; }
    #kls-chat-launcher.open .kls-icon-chat { opacity: 0; }
    #kls-chat-launcher.open .kls-icon-close { opacity: 1; }

    #kls-chat-bubble {
      position: fixed;
      bottom: 90px;
      right: 24px;
      width: 360px;
      max-width: calc(100vw - 32px);
      height: 520px;
      max-height: calc(100vh - 110px);
      background: #FAFAF8;
      border-radius: 16px;
      box-shadow: 0 8px 40px rgba(0,0,0,0.18);
      z-index: 9998;
      display: none;
      flex-direction: column;
      overflow: hidden;
      font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
      border: 1px solid rgba(201,169,110,0.3);
    }
    #kls-chat-bubble.visible { display: flex; }

    .kls-chat-header {
      background: #1C1C1C;
      padding: 16px 20px;
      display: flex;
      align-items: center;
      gap: 12px;
      flex-shrink: 0;
    }
    .kls-chat-header-avatar {
      width: 36px;
      height: 36px;
      border-radius: 50%;
      background: #C9A96E;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 16px;
      flex-shrink: 0;
    }
    .kls-chat-header-info { flex: 1; }
    .kls-chat-header-name {
      color: #FAFAF8;
      font-size: 14px;
      font-weight: 600;
      letter-spacing: 0.05em;
    }
    .kls-chat-header-status {
      color: #C9A96E;
      font-size: 11px;
      letter-spacing: 0.08em;
      text-transform: uppercase;
    }

    .kls-chat-messages {
      flex: 1;
      overflow-y: auto;
      padding: 16px;
      display: flex;
      flex-direction: column;
      gap: 12px;
      scroll-behavior: smooth;
    }
    .kls-chat-messages::-webkit-scrollbar { width: 4px; }
    .kls-chat-messages::-webkit-scrollbar-track { background: transparent; }
    .kls-chat-messages::-webkit-scrollbar-thumb { background: #ddd; border-radius: 2px; }

    .kls-msg {
      max-width: 85%;
      padding: 10px 14px;
      border-radius: 12px;
      font-size: 14px;
      line-height: 1.5;
      color: #1C1C1C;
    }
    .kls-msg-bot {
      background: #fff;
      border: 1px solid #e8e5e0;
      border-bottom-left-radius: 4px;
      align-self: flex-start;
    }
    .kls-msg-user {
      background: #1C1C1C;
      color: #FAFAF8;
      border-bottom-right-radius: 4px;
      align-self: flex-end;
    }
    .kls-msg-typing {
      background: #fff;
      border: 1px solid #e8e5e0;
      border-bottom-left-radius: 4px;
      align-self: flex-start;
      padding: 12px 16px;
    }
    .kls-typing-dots { display: flex; gap: 4px; align-items: center; }
    .kls-typing-dots span {
      width: 6px; height: 6px;
      background: #C9A96E;
      border-radius: 50%;
      animation: kls-bounce 1.2s infinite;
    }
    .kls-typing-dots span:nth-child(2) { animation-delay: 0.2s; }
    .kls-typing-dots span:nth-child(3) { animation-delay: 0.4s; }
    @keyframes kls-bounce {
      0%, 60%, 100% { transform: translateY(0); }
      30% { transform: translateY(-6px); }
    }

    .kls-quick-replies {
      display: flex;
      flex-wrap: wrap;
      gap: 8px;
      padding: 4px 16px 12px;
      flex-shrink: 0;
    }
    .kls-quick-btn {
      background: transparent;
      border: 1px solid #C9A96E;
      color: #8B5E6B;
      padding: 6px 12px;
      border-radius: 20px;
      font-size: 12px;
      cursor: pointer;
      transition: background 0.15s, color 0.15s;
      font-family: inherit;
      white-space: nowrap;
    }
    .kls-quick-btn:hover { background: #C9A96E; color: #1C1C1C; }

    .kls-chat-input-row {
      display: flex;
      align-items: flex-end;
      gap: 8px;
      padding: 12px 16px;
      background: #fff;
      border-top: 1px solid #e8e5e0;
      flex-shrink: 0;
    }
    .kls-chat-input {
      flex: 1;
      border: 1px solid #e0ddd8;
      border-radius: 20px;
      padding: 10px 16px;
      font-size: 14px;
      font-family: inherit;
      resize: none;
      outline: none;
      line-height: 1.4;
      max-height: 96px;
      overflow-y: auto;
      color: #1C1C1C;
      background: #FAFAF8;
      transition: border-color 0.15s;
    }
    .kls-chat-input:focus { border-color: #C9A96E; }
    .kls-chat-input::placeholder { color: #aaa; }
    .kls-send-btn {
      width: 36px;
      height: 36px;
      border-radius: 50%;
      background: #1C1C1C;
      border: none;
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-shrink: 0;
      transition: background 0.15s;
    }
    .kls-send-btn:hover { background: #C9A96E; }
    .kls-send-btn:disabled { opacity: 0.4; cursor: default; }
    .kls-send-btn svg { pointer-events: none; }

    .kls-chat-footer {
      text-align: center;
      padding: 6px;
      font-size: 10px;
      color: #bbb;
      letter-spacing: 0.06em;
      text-transform: uppercase;
      background: #fff;
    }
  `;

  // ── HTML ───────────────────────────────────────────────────────────────────
  function buildWidget() {
    const style = document.createElement("style");
    style.textContent = css;
    document.head.appendChild(style);

    // Launcher button
    const launcher = document.createElement("div");
    launcher.id = "kls-chat-launcher";
    launcher.setAttribute("aria-label", "Open chat");
    launcher.innerHTML = `
      <svg class="kls-icon-chat" width="24" height="24" viewBox="0 0 24 24" fill="none">
        <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" stroke="#C9A96E" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
      <svg class="kls-icon-close" width="20" height="20" viewBox="0 0 24 24" fill="none">
        <line x1="18" y1="6" x2="6" y2="18" stroke="#C9A96E" stroke-width="2" stroke-linecap="round"/>
        <line x1="6" y1="6" x2="18" y2="18" stroke="#C9A96E" stroke-width="2" stroke-linecap="round"/>
      </svg>
    `;

    // Chat bubble
    const bubble = document.createElement("div");
    bubble.id = "kls-chat-bubble";
    bubble.setAttribute("role", "dialog");
    bubble.setAttribute("aria-label", "Customer service chat");
    bubble.innerHTML = `
      <div class="kls-chat-header">
        <div class="kls-chat-header-avatar">✦</div>
        <div class="kls-chat-header-info">
          <div class="kls-chat-header-name">Kendall Layne Studio</div>
          <div class="kls-chat-header-status">● Here to help</div>
        </div>
      </div>
      <div class="kls-chat-messages" id="kls-messages"></div>
      <div class="kls-quick-replies" id="kls-quick-replies"></div>
      <div class="kls-chat-input-row">
        <textarea class="kls-chat-input" id="kls-input" placeholder="Ask about your order or our jewelry…" rows="1"></textarea>
        <button class="kls-send-btn" id="kls-send" aria-label="Send">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
            <line x1="22" y1="2" x2="11" y2="13" stroke="#FAFAF8" stroke-width="2" stroke-linecap="round"/>
            <polygon points="22 2 15 22 11 13 2 9 22 2" stroke="#FAFAF8" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" fill="none"/>
          </svg>
        </button>
      </div>
      <div class="kls-chat-footer">Powered by KLS × Claude AI</div>
    `;

    document.body.appendChild(launcher);
    document.body.appendChild(bubble);

    return { launcher, bubble };
  }

  // ── Logic ──────────────────────────────────────────────────────────────────
  function init() {
    const { launcher, bubble } = buildWidget();
    const messagesEl = document.getElementById("kls-messages");
    const inputEl = document.getElementById("kls-input");
    const sendBtn = document.getElementById("kls-send");
    const quickEl = document.getElementById("kls-quick-replies");

    let conversationHistory = [];
    let isOpen = false;
    let isLoading = false;

    // Extract markdown links and return { cleanText, buttons: [{label, url}] }
    function parseMessage(text) {
      const buttons = [];
      // Extract [label](url) — collect as buttons
      const cleanText = text
        .replace(/\[([^\]]+)\]\((https?:\/\/[^\)]+)\)/g, (_, label, url) => {
          buttons.push({ label, url });
          return "";
        })
        // Also catch bare URLs
        .replace(/(https?:\/\/[^\s]+)/g, (_, url) => {
          const label = url.replace(/^https?:\/\/(www\.)?/, "").replace(/\/$/, "");
          buttons.push({ label, url });
          return "";
        })
        .replace(/\s{2,}/g, " ")
        .replace(/\.\s*$/, ".")
        .trim();
      return { cleanText, buttons };
    }

    function addMessage(text, role) {
      const wrapper = document.createElement("div");
      wrapper.style.cssText = "display:flex;flex-direction:column;align-items:" + (role === "bot" ? "flex-start" : "flex-end") + ";gap:6px;";

      const div = document.createElement("div");
      div.className = `kls-msg kls-msg-${role}`;

      if (role === "bot") {
        const { cleanText, buttons } = parseMessage(text);
        div.textContent = cleanText;
        wrapper.appendChild(div);
        if (buttons.length > 0) {
          const btnRow = document.createElement("div");
          btnRow.style.cssText = "display:flex;flex-wrap:wrap;gap:6px;padding:0 2px;";
          buttons.forEach(({ label, url }) => {
            const a = document.createElement("a");
            a.href = url;
            a.target = "_blank";
            a.rel = "noopener";
            a.textContent = label;
            a.style.cssText = "display:inline-block;padding:7px 14px;border:1px solid #C9A96E;color:#1C1C1C;border-radius:20px;font-size:12px;text-decoration:none;background:#fff;cursor:pointer;transition:background 0.15s,color 0.15s;white-space:nowrap;font-family:inherit;";
            a.onmouseover = () => { a.style.background = "#C9A96E"; a.style.color = "#fff"; };
            a.onmouseout = () => { a.style.background = "#fff"; a.style.color = "#1C1C1C"; };
            btnRow.appendChild(a);
          });
          wrapper.appendChild(btnRow);
        }
      } else {
        div.textContent = text;
        wrapper.appendChild(div);
      }

      messagesEl.appendChild(wrapper);
      messagesEl.scrollTop = messagesEl.scrollHeight;
      return wrapper;
    }

    // Show / hide typing indicator
    function showTyping() {
      const div = document.createElement("div");
      div.className = "kls-msg kls-msg-typing";
      div.id = "kls-typing";
      div.innerHTML = `<div class="kls-typing-dots"><span></span><span></span><span></span></div>`;
      messagesEl.appendChild(div);
      messagesEl.scrollTop = messagesEl.scrollHeight;
    }

    function hideTyping() {
      document.getElementById("kls-typing")?.remove();
    }

    // Render quick reply chips
    function showQuickReplies(replies) {
      quickEl.innerHTML = "";
      replies.forEach((text) => {
        const btn = document.createElement("button");
        btn.className = "kls-quick-btn";
        btn.textContent = text;
        btn.onclick = () => sendMessage(text);
        quickEl.appendChild(btn);
      });
    }

    // Send message to backend
    async function sendMessage(text) {
      if (!text.trim() || isLoading) return;

      quickEl.innerHTML = "";
      addMessage(text, "user");
      inputEl.value = "";
      inputEl.style.height = "auto";

      conversationHistory.push({ role: "user", content: text });
      isLoading = true;
      sendBtn.disabled = true;
      showTyping();

      try {
        const res = await fetch(`${KLS_AGENT_URL}/api/chat`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ messages: conversationHistory }),
        });

        const data = await res.json();
        hideTyping();

        if (data.reply) {
          addMessage(data.reply, "bot");
          conversationHistory.push({ role: "assistant", content: data.reply });
        } else {
          addMessage("I'm sorry, I had trouble with that. Please email questions@kendalllaynestudio.com and we'll help you right away.", "bot");
        }
      } catch {
        hideTyping();
        addMessage("I'm having trouble connecting right now. Please email questions@kendalllaynestudio.com and we'll get back to you quickly!", "bot");
      } finally {
        isLoading = false;
        sendBtn.disabled = false;
        inputEl.focus();
      }
    }

    // Toggle open/close
    function toggle() {
      isOpen = !isOpen;
      launcher.classList.toggle("open", isOpen);
      bubble.classList.toggle("visible", isOpen);

      if (isOpen && messagesEl.children.length === 0) {
        // First open — show welcome message and quick replies
        setTimeout(() => {
          showTyping();
          setTimeout(() => {
            hideTyping();
            addMessage(WELCOME_MSG, "bot");
            showQuickReplies(QUICK_REPLIES);
          }, 800);
        }, 200);
      }

      if (isOpen) inputEl.focus();
    }

    // Events
    launcher.addEventListener("click", toggle);

    sendBtn.addEventListener("click", () => sendMessage(inputEl.value));

    inputEl.addEventListener("keydown", (e) => {
      if (e.key === "Enter" && !e.shiftKey) {
        e.preventDefault();
        sendMessage(inputEl.value);
      }
    });

    // Auto-resize textarea
    inputEl.addEventListener("input", () => {
      inputEl.style.height = "auto";
      inputEl.style.height = Math.min(inputEl.scrollHeight, 96) + "px";
    });
  }

  // Init when DOM is ready
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
